import dayjs from 'dayjs';
import {
    ProblemMinimal,
    ProblemMinimalWithAuthorAndCreated,
    SimilarProblem,
} from '@types';
import {type CSSProperties} from 'react';
import {Card, Badge} from '@goproblems/ui';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {
    faCheckCircle,
    faCircleXmark,
    faClock,
    faUser,
} from '@fortawesome/free-solid-svg-icons';
import RankText from './common/RankText';

export const ProblemCard = ({
    problem,
    className = 'w-[150px] text-lg cursor-pointer',
    bodyClassName = 'p-2',
    solved = false,
    showBody = true,
    showSolved = true,
    rankBadgeStyle,
    onClick,
}: {
    problem:
        | ProblemMinimalWithAuthorAndCreated
        | ProblemMinimal
        | SimilarProblem;
    className?: string;
    bodyClassName?: string;
    solved?: boolean;
    showBody?: boolean;
    showSolved?: boolean;
    rankBadgeStyle?: CSSProperties;
    onClick?: () => void;
}) => {
    return (
        <Card className={className} onClick={onClick}>
            <div className="flex absolute w-100">
                {problem && 'rank' in problem && (
                    <Badge
                        className="absolute mt-1 ms-1 rounded-sm left-0"
                        style={rankBadgeStyle}
                        bg="light">
                        <RankText rank={problem.rank} />
                    </Badge>
                )}
                {showSolved && (
                    <Badge className="absolute bg-light mt-1 me-1 float-end lh-1 right-0">
                        <FontAwesomeIcon
                            icon={solved ? faCheckCircle : faCircleXmark}
                            className={solved ? 'text-success' : 'text-danger'}
                        />
                    </Badge>
                )}
                <span className="badge bg-light  mt-1 ms-1"></span>
            </div>
            {problem && 'imageDataUrl' in problem && (
                <Card.Img variant="top" src={problem.imageDataUrl} />
            )}
            {problem && 'imageUrl' in problem && (
                <Card.Img variant="top" src={problem.imageUrl} />
            )}
            {showBody && (
                <Card.Body className={bodyClassName}>
                    <span className="text-muted d-inline-block text-truncate max-width-140">
                        {'createdAt' in problem && (
                            <small>
                                <FontAwesomeIcon icon={faClock} />
                                <span className="ml-1">
                                    {dayjs(problem.createdAt).fromNow()}
                                </span>
                            </small>
                        )}
                        {'author' in problem && (
                            <>
                                <br />
                                <small>
                                    <FontAwesomeIcon icon={faUser} />
                                    <span className="ml-1">
                                        {problem.author.name}
                                    </span>
                                </small>
                            </>
                        )}
                    </span>
                </Card.Body>
            )}
        </Card>
    );
};
